import { Draggable } from '@hello-pangea/dnd';
import { Control, UseFormRegister } from 'react-hook-form';

import config from '../../../config';
import { InquiryForm, InquiryItem } from '../../../models/Inquiry/Inquiry';
import FormContentChildren from './FormContentItemChildren';

interface Props {
  item: InquiryItem
  index: number
  register: UseFormRegister<InquiryForm>
  control: Control<InquiryForm, any>
  onRemove: (id: number) => void
  disabled: boolean
}

export default function FormContentItem({
  item, index, register, control, onRemove, disabled,
}: Props) {
  if (item.type === config.items.types.group.value) {
    return (
      <Draggable
        key={item.uuid}
        draggableId={String(item.uuid)}
        index={index}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{ ...provided.draggableProps.style }}
            className="user-select-none list-group-item list-group-item-action gap-2"
          >
            <div className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center justify-content-between">
                <div className="flex-fill">
                  <i className="fa-solid fa-bars fa-fw me-2" />
                  <span className="fw-bold">{item.label}</span>
                </div>
                <div className="controls">
                  <button type="button" className="btn-close" aria-label="Close" onClick={() => { onRemove(index); }} />
                </div>
              </div>
              <FormContentChildren
                fieldIndex={index}
                register={register}
                control={control}
                disabled={disabled}
              />
            </div>
          </div>
        )}
      </Draggable>
    );
  }

  return (
    <Draggable
      key={item.uuid}
      draggableId={String(item.uuid)}
      index={index}
    >
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{ ...provided.draggableProps.style }}
          className="user-select-none list-group-item list-group-item-action gap-2"
        >
          <div className="d-flex flex-column gap-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="flex-fill">
                <i className="fa-solid fa-bars fa-fw me-2" />
                <span className="fw-bold">{item.label}</span>
              </div>
              <div className="controls">
                <button type="button" className="btn-close" aria-label="Close" onClick={() => { onRemove(index); }} />
              </div>
            </div>
            <div className="d-flex flex-column option-item">
              <div className="d-flex flex-wrap align-items-center col-gap-3">
                <div className="form-check form-switch">
                  <input
                    id={`required_${item.id}`}
                    key={item.id}
                    {...register(`definition.${index}.required`)}
                    type="checkbox"
                    className="form-check-input"
                    disabled={disabled}
                  />
                  <label className="form-check-label" htmlFor={`required_${item.id}`}>必須項目</label>
                </div>
              </div>
            </div>
            <div className="d-flex flex-column option-info">
              <div className="d-flex flex-wrap align-items-center gap-2">
                <div className="text-sm">
                  項目タイプ：
                  <span>{Object.values(config.items.types).find((i) => i.value === item?.type)?.label}</span>
                </div>
                <div className="text-sm">
                  項目プレースホルダー：
                  <span>{item?.placeholder || 'なし'}</span>
                </div>
                {
                  [
                    config.items.types.text.value,
                    config.items.types.textarea.value,
                    config.items.types.date.value,
                    config.items.types.checkbox.value,
                    config.items.types.select.value,
                    config.items.types.number.value,
                    config.items.types.email.value,
                  ].includes(item.type) && (
                    <>
                      <div className="text-sm">
                        接頭辞：
                        <span>{item?.prefix || 'なし'}</span>
                      </div>
                      <div className="text-sm">
                        接尾辞：
                        <span>{item?.suffix || 'なし'}</span>
                      </div>
                    </>
                  )
                }
                {
                  [
                    config.items.types.text.value,
                    config.items.types.textarea.value,
                  ].includes(item.type) && (
                    <div className="text-sm">
                      文字数上限：
                      <span>{item?.max_length || 'なし'}</span>
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  );
}
